import {FC, PropsWithChildren} from "react";
import "./QueryExample.scss";

export const QueryExample: FC<PropsWithChildren> = ({children}) => {
  return <code className={"query-example"}>{children}</code>;
};
